exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-4fe8b5c5] {\n  width: 8rem;\n  display: block;\n  margin: 1rem auto;\n}\n", ""]);

// exports
